import React from 'react';
import { getRandomInt } from '../../../apps/Cards/utils/utils';
import './ImageCover.scss';

export function ImageCover({ color, text }) {
  const value = getRandomInt(0, 20);
  const opacity = value / 100;
  const background = value % 2 ? `rgba(0, 0, 0, ${opacity})` : `rgba(255, 255, 255, ${opacity})`;

  return (
    <div
      className="imageCover"
      style={{ '--color': color }}
    >
      <div className="imageCover__bg" style={{ background }} />
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}
